// Lead magnets — FREE, email-gated. Delivered by SendGrid via signed PDF link.

export const RESOURCES = {
  "authority-audit-checklist": {
    slug: "authority-audit-checklist",
    name: "Authority Audit Checklist",
    blurb: "The exact 7-dimension checklist used inside the $49 Authority Audit. Score yourself in under 15 minutes.",
    pages: 14,
    type: "Checklist",
    accent: "#ba7a30",
    fileUrl: "",
    cta: "Get Your Free Checklist",
  },
  "50-authority-building-ideas": {
    slug: "50-authority-building-ideas",
    name: "50 Authority Building Ideas",
    blurb: "Fifty plug-and-play ideas for content, lead magnets, and tools — categorized by effort and impact.",
    pages: 22,
    type: "Idea Bank",
    accent: "#5a8aeb",
    fileUrl: "",
    cta: "Get the Free Idea Bank",
  },
};

export const RESOURCE_LIST = Object.values(RESOURCES);
